import Vue from 'vue'
// 限制输入带两位小数点金额指令
Vue.directive('num', {
  inserted(el) {
    const trigger = (el, type) => {
      const e = document.createEvent('HTMLEvents')
      e.initEvent(type, true, true)
      el.dispatchEvent(e)
    }
    el.addEventListener('keyup', function(e) {
      const input = e.target
      if (!/((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/.test(input.value)) {
        input.value = ''
      }
      trigger(input, 'input')
    })
    el.addEventListener('blur', function(e) {
      const input = e.target
      if (input.value) {
        input.value = parseFloat(input.value)
        trigger(input, 'input')
      }
    })
  },
})
// 限制输入带两位小数点正负数
Vue.directive('normal', {
  inserted(el) {
    const trigger = (el, type) => {
      const e = document.createEvent('HTMLEvents')
      e.initEvent(type, true, true)
      el.dispatchEvent(e)
    }
    el.addEventListener('keyup', function(e) {
      const input = e.target
      if (!/^([-?[0-9]{0,1}|[0-9])+\.?[0-9]{0,2}$/.test(input.value)) {
        input.value = ''
      }
      trigger(input, 'input')
    })
    el.addEventListener('blur', function(e) {
      const input = e.target
      if (input.value) {
        input.value = parseFloat(input.value)
        trigger(input, 'input')
      }
    })
  },
})

// 限制输入大于等于1的整数
Vue.directive('int', {
  inserted(el) {
    const trigger = (el, type) => {
      const e = document.createEvent('HTMLEvents')
      e.initEvent(type, true, true)
      el.dispatchEvent(e)
    }
    el.addEventListener('keyup', function(e) {
      const input = e.target
      if (parseInt(input.value) === 1) {
        input.value = 1
      } else if (/^0+/.test(input.value)) {
        // 01000
        input.value = input.value.replace(/^0+/, '')
      } else {
        input.value = input.value.replace(/\D/g, '')
      }
      trigger(input, 'input')
    })
    el.addEventListener('blur', function(e) {
      const input = e.target
      if (input.value) {
        input.value = parseInt(input.value)
        trigger(input, 'input')
      }
    })
  },
})



// WEBPACK FOOTER //
// ./src/utils/directives.js